import { useEffect, useState } from 'react';
import { Link, Navigate, useSearchParams } from 'react-router-dom';
import { useAuth } from '../lib/auth';
import { errorText } from '../lib/errors';
import { safeNext } from '../components/GoogleSignIn';
import { LOGO_SRC, Splash } from '../components/ui';

/**
 * Where Google sends people back (/auth/callback?next=…&code=…). The Supabase client swaps the code for a session on
 * load; then this goes on to where they were heading, or the welcome screen if they aren't in a family yet.
 */
export default function AuthCallback() {
  const { ready, session } = useAuth();
  const [params] = useSearchParams();
  const next = safeNext(params.get('next'));
  const failed = params.get('error_description') || params.get('error');
  const [slow, setSlow] = useState(false);
  useEffect(() => {
    const t = setTimeout(() => setSlow(true), 12_000);
    return () => clearTimeout(t);
  }, []);

  if (ready && session) return <Navigate to={next} replace />;
  if (!failed && !slow) return <Splash />;
  return (
    <div className="shell">
      <div className="auth">
        <span className="brand-chip"><img src={LOGO_SRC} alt="ONE10" style={{ height: 40 }} /></span>
        <h1>Google sign-in didn't finish</h1>
        <p className="muted">
          {failed ? errorText(failed) : 'It is taking too long.'} Try again, or sign in with your email instead: we email you a 6-digit code.
        </p>
        <Link className="btn primary block lg" to={`/signin?next=${encodeURIComponent(next)}`}>Back to sign-in</Link>
      </div>
    </div>
  );
}
